@if (detailApiError()) {
    <tec-alert
        [hiddenCloseButton]="true"
        [msg]="detailApiError()"
        [status]="'error'"
        (closeAlert)="clearDetailApiError()"
    />
}
@if (detailLoading) {
<tec-create-layout>
    <div class="design-detail__back">
        <tec-link [size]="'sm'" [label]="'BUTTON.BACK' | translate" (click)="onBackClick($event)">
            <tec-icon [name]="'icon-arrow-left'" [size]="'sm'" />
        </tec-link>
    </div>
    <tec-item [loading]="true" [size]="'lg'" />
    <div class="layout--60-40 design-detail__skeleton">
        <div class="design-detail__skeleton-tiles">
            @for (skeleton of detailSkeletonTiles; track skeleton) {
                <tec-tile [loading]="true" />
            }
        </div>
        <tec-tile [loading]="true" />
    </div>
</tec-create-layout>
} @else if (detail) {
<tec-create-layout [formGroup]="form">
    <div class="design-detail__back">
        <tec-link [size]="'sm'" [label]="'BUTTON.BACK' | translate" (click)="onBackClick($event)">
            <tec-icon [name]="'icon-arrow-left'" [size]="'sm'" />
        </tec-link>
    </div>
    <tec-item
        [size]="'lg'"
        [tagImage]="{ icon: 'icon-customize', status: 'default' }"
        [title]="detail.title"
        [detailAction]="detailDateLabel"
        [clickeable]="rolePermissions.canEditDesignConfig()"
    >
        <tec-tag [status]="detail.active ? 'success' : 'disabled'">
            {{ (detail.active ? 'DESIGN.ACTIVE' : 'DESIGN.INACTIVE') | translate }}
        </tec-tag>
        @if (companyLabel) {
            <tec-list-detail>
                <span>{{ (detail.skin === 'dark' ? 'DESIGN.THEMES.DARK' : 'DESIGN.THEMES.LIGHT') | translate }}</span>
                <span>{{ companyLabel }}</span>
            </tec-list-detail>
        }
        @if (detailMenuOpt.length > 0) {
            <tec-menu [options]="detailMenuOpt" (valueChange)="detailMenuChange($event)">
                <tec-button-icon [icon]="'icon-more'" [type]="'default'" />
            </tec-menu>
        }
    </tec-item>

    @if (themeFormControl) {
        <app-design-theme-detail
            [formControl]="themeFormControl"
            [themeMode]="selectedTab"
            (themeEdited)="onThemeEdited()"
        />
    }

    @if (rolePermissions.canEditDesignConfig() && hasChanges) {
        <tec-footer-actions>
            <tec-button [label]="'BUTTON.EXIT' | translate" [type]="'secondary'" (clickEvent)="exit()" />
            <tec-button [label]="'BUTTON.SAVE' | translate" (clickEvent)="saveChangesAndExit()" />
        </tec-footer-actions>
    }
</tec-create-layout>
}
@if (showModalEditTheme && themeEditData) {
    <app-modal-design-theme [data]="themeEditData" [isEditMode]="true" (closeEvent)="closeModalEditTheme($event)" />
}
@if (showModalCancelDesign) {
    <app-modal-cancel-design [isVisible]="true" (closeEvent)="closeModalCancelDesign($event)" />
}
@if (curlModalOpen()) {
    <app-modal-curl-request
        [titleKey]="curlModalTitleKey()"
        [curlText]="curlModalText()"
        [showCancelButton]="false"
        (closeEvent)="closeCurlModal()"
    />
}
